/**
 * The app version format shared by every Notability client: `yy.ww.N`, three integers, nothing else.
 * Kept here rather than beside either validator because the same rule is enforced twice — once in
 * the admin form an operator types into, once on the server that accepts what it sends — and the two
 * disagreeing would let a value through one and be rejected by the other.
 *
 * Ordering comparisons live in `common-backend`'s `VersionUtils`, which needs semver; this file
 * stays dependency-free so frontends can validate without pulling one in.
 */

const ExactVersionPattern = /^\d+\.\d+\.\d+$/

/** Whether `value` is exactly three dot-separated integers, e.g. `26.38.22`. */
export function isExactVersion(value: string): boolean {
  return ExactVersionPattern.test(value)
}
